export { default as Img200 } from './processed/200/Krypton-cropped.jpg';
export { default as Img400 } from './processed/400/Krypton-cropped.jpg';
export { default as Imgthumb } from './processed/thumb/Krypton-cropped.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Krypton-cropped.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Krypton-cropped.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      223,
      35,
      9
    ],
    "_population": 3538,
    "_hsl": [
      0.020249221183800625,
      0.9224137931034483,
      0.4549019607843137
    ]
  },
  "LightVibrant": {
    "_rgb": [
      245,
      223,
      128
    ],
    "_population": 144,
    "_hsl": [
      0.13532763532763534,
      0.8540145985401463,
      0.7313725490196079
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      124,
      14,
      6
    ],
    "_population": 3384,
    "_hsl": [
      0.011299435028248588,
      0.9076923076923078,
      0.2549019607843137
    ]
  },
  "Muted": {
    "_rgb": [
      124,
      116,
      108
    ],
    "_population": 1,
    "_hsl": [
      0.08333333333333333,
      0.06896551724137931,
      0.4549019607843137
    ]
  },
  "DarkMuted": {
    "_rgb": [
      92,
      72,
      55
    ],
    "_population": 15,
    "_hsl": [
      0.07657657657657657,
      0.25170068027210885,
      0.28823529411764703
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Krypton-cropped.js